export const extraParams = {
  withKoniki: '256',
  adr: '64',
  roundTrip: '4',
  permanent: '128',
  tenders: 'excludeTenders',
  isRateInThousands: '4096',
};
